export const States = {
    1: 'Andhra Pradesh',
    2: 'Arunachal Pradesh',
    3: 'Assam',
    4: 'Bihar',
    5: 'Chhattisgarh',
    6: 'Goa',
    7: 'Gujarat',
    8: 'Haryana',
    9: 'Himachal Pradesh',
    10: 'Jammu & Kashmir',
    11: 'Jharkhand',
    12: 'Karnataka',
    13: 'Kerala',
    14: 'Madhya Pradesh',
    15: 'Maharashtra',
    16: 'Manipur',
    17: 'Meghalaya',
    18: 'Mizoram',
    19: 'Nagaland',
    20: 'Odisha',
    21: 'Punjab',
    22: 'Rajasthan',
    23: 'Sikkim',
    24: 'Tamil Nadu',
    25: 'Tripura',
    26: 'Uttarakhand',
    27: 'Uttar Pradesh',
    28: 'West Bengal',
    29: 'Andaman & Nicobar',
    30: 'Chandigarh',
    31: 'Dadra and Nagar Haveli',
    32: 'Daman & Diu',
    33: 'Delhi',
    34: 'Lakshadweep',
    35: 'Puducherry',
};

export const StatesList = Object.values(States).sort();